import script from "./Question.vue?vue&type=script&setup=true&lang=js"
export * from "./Question.vue?vue&type=script&setup=true&lang=js"

import "./Question.vue?vue&type=style&index=0&id=35a9a915&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a9a915"]])

export default __exports__